// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2ZimJ","content":"styles_content__3ntG6","checkbox":"styles_checkbox__1VQ-4","checkboxLabel":"styles_checkboxLabel__2aVl9"};